import api from '../util/instance';
import { urls } from './Api';

export const fetchTrades = async (id) => await api.get(`${urls.fetchTrades}/${id}`);

export const updatePublicTrade = async () => await api.post(urls.updatePublicTrade);
